import { Table } from "antd";
import React, { useState } from "react";

const AntDesignTable = (props) => {
  const {
    columns,
    tableData,
    setSelectedRowKeys,
    selectedRowKeys: propsSelectedRowKeys,
    rowKey,
  } = props;
  const [selectionType, setSelectionType] = useState("checkbox");
  const [selectedRowKeysLocal, setSelectedRowKeysLocal] = useState([]);

  const activeSelectedRowKeys =
    propsSelectedRowKeys !== undefined
      ? propsSelectedRowKeys
      : selectedRowKeysLocal;

  const rowSelection = {
    selectedRowKeys: activeSelectedRowKeys,
    onChange: (newSelectedRowKeys, selectedRows) => {
      setSelectedRowKeysLocal(newSelectedRowKeys);
      if (typeof setSelectedRowKeys === "function") {
        setSelectedRowKeys(newSelectedRowKeys);
      }

    },
    getCheckboxProps: (record) => ({
      disabled: record?.name === "Disabled User",
      name: record?.name,
    }),
  };

  const getRowKey = (record, index) => {
    if (typeof rowKey === "function") {
      return rowKey(record);
    }
    if (typeof rowKey === "string" && record && record[rowKey] !== undefined) {
      return record[rowKey];
    }
    if (!record) return index;
    if (record.id !== undefined) return record.id;
    if (record._id !== undefined) return record._id;
    if (record.doctor_id !== undefined) return record.doctor_id;
    if (record.patient_id !== undefined) return record.patient_id;
    if (record.device_id !== undefined) return record.device_id;
    if (record.kiosk_id !== undefined) return record.kiosk_id;
    if (record.tablet_id !== undefined) return record.tablet_id;
    if (record.medicine_id !== undefined) return record.medicine_id;
    if (record.transaction_id !== undefined) return record.transaction_id;
    if (record.appointment_id !== undefined) return record.appointment_id;
    if (record.key !== undefined) return record.key;
    return index;
  };

  return (
    <React.Fragment>
      <Table
        rowKey={getRowKey}
        columns={columns}
        dataSource={tableData}
        rowSelection={{
          type: selectionType,
          ...rowSelection,
        }}
      />
    </React.Fragment>
  );
};

export default AntDesignTable;
